<template>
  <v-app>
    <!-- Desktop App Bar -->
    <DesktopAppBar v-if="$vuetify.breakpoint.width >= 1200"></DesktopAppBar>
    <!-- Mobile App Bar -->
    <MobileAppBar v-if="$vuetify.breakpoint.width < 1200"
                  @menu="showMobileMenu = !showMobileMenu"></MobileAppBar>
    <MobileNavigationDrawer v-if="$vuetify.breakpoint.width < 1200"
                            v-model="showMobileMenu"></MobileNavigationDrawer>
    <!-- Sizes your content based upon application components -->
    <v-main class="mx-lg-8 mx-xl-12">
      <router-view/>
    </v-main>
    <Footer></Footer>

    <v-dialog v-model="showAlertDialog"
              max-width="290">
      <v-card>
        <v-card-text class="pa-3">{{ alertMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <div v-if="alertActions">
            <v-btn v-for="(action, index) in alertActions"
                   v-bind:key="'alert_action_' + index"
                   text
                   :color="action['color'] || 'rgb(142, 118, 91)'"
                   @click="afterDialog(index)">
              {{ action['text'] || $t('close') }}
            </v-btn>
          </div>
          <v-btn v-else
                 text
                 color="rgb(142, 118, 91)"
                 @click="afterDialog">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isLoading"
               z-index="9999">
      <GridLoader color="#8E765B"></GridLoader>
    </v-overlay>
  </v-app>
</template>

<script>
import GridLoader from 'vue-spinner/src/GridLoader.vue'
import {onBeforeMount, onMounted, ref, computed} from '@vue/composition-api';
import DesktopAppBar from "@/components/DesktopAppBar";
import Footer from "@/components/Footer";
import MobileAppBar from "@/components/MobileAppBar";
import MobileNavigationDrawer from "@/components/MobileNavigationDrawer";

export default {
  name: 'App',
  components: {MobileNavigationDrawer, MobileAppBar, Footer, DesktopAppBar, GridLoader},
  setup(props, {root}) {
    const locale = ref(null);

    const showAlertDialog = ref(false);
    const alertMessage = ref('');
    const alertHandler = ref(null);
    const alertActions = ref([]);
    const afterDialog = function () {
      showAlertDialog.value = false;
      if (alertHandler.value) alertHandler.value();
    }

    const isLoading = computed(() => root.$store.getters.requestCount !== 0);

    const showMobileMenu = ref(false);

    onBeforeMount(() => {
      locale.value = root.$cookie.get('locale') || 'en';

      let l = (new URL(document.location)).searchParams.get('locale');
      if (l) {
        locale.value = l;
        window.history.replaceState(null, null, window.location.pathname+window.location.hash);
      }

      root.$cookie.set('locale', locale.value, {samesite: 'Strict', secure: true});
      root.$i18n.locale = locale.value;
    });

    onMounted(() => {
      root.$eventHub.$on('showAlertMessage', ({message, handler, actions}) => {
        alertMessage.value = message || this.$t('error_msg');
        alertHandler.value = handler;
        alertActions.value = actions;
        showAlertDialog.value = true;
      })
    })

    return {
      showAlertDialog,
      alertMessage,
      alertActions,
      afterDialog,

      isLoading,

      showMobileMenu,
    }
  },
};
</script>

<style lang="less">
@import "./styles/client/main";
//
//.container {
//  .col {
//    padding-top: 0;
//  }
//}
</style>
